import initVue from "./vue/init";
import initMenu from "./main-menu";
import animationsV2 from "./animationsv2";

function ready(fn) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

ready(() => {
  initVue();
  initMenu();
  animationsV2();

  var el = document.getElementById("generic-dialog");
  if (el) {
    const search = document.getElementById("s");

    if (search && search.value != "") {
      search.classList.add("generic-dialog__group__input--dirty");
    } else {
      search.classList.remove("generic-dialog__group__input--dirty");
    }

    document.querySelector("#s").addEventListener("change", function () {
      if (this.value != "") {
        this.classList.add("generic-dialog__group__input--dirty");
      } else {
        this.classList.remove("generic-dialog__group__input--dirty");
      }
    });
  }
});
